import { render, staticRenderFns } from "./team2.vue?vue&type=template&id=d49042ec&"
import script from "./team2.vue?vue&type=script&lang=js&"
export * from "./team2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports